module.exports = __webpack_public_path__ + "img/article8.eae167f0.jpg";